import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { CategoriaProduto } from './model/categoria-produto.model';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';


@Injectable({
  providedIn: 'root'
})
export class CategoriaProdutoService extends DefaultService<CategoriaProduto> {

  static url = '/api/farmacia/categoriaproduto/v1/categoriaProduto';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, errorHandlerService, CategoriaProdutoService.url);
  }

  static getNomesDasCategoriasDoArray(categoriasProduto: CategoriaProduto[]): string {
    let nomesDasCategorias = '';
    if ( categoriasProduto ) {
      categoriasProduto
        .forEach(cp => nomesDasCategorias += (nomesDasCategorias ? ', ' : '') + cp.nome);
    }

    return nomesDasCategorias;
  }

  static getIdsDasCategoriasDoArray(categoriasProduto: CategoriaProduto[]): string {
    let ids = '';
    if ( categoriasProduto ) {
      categoriasProduto
        .forEach(cp => ids += (ids ? ',' : '') + cp.id);
    }

    return ids;
  }

  static parseCategoriasProdutoToHTML(categoriasProduto: string): string {
    let o = '';
    if ( categoriasProduto ) {
      const _categoriasProduto = JSON.parse(categoriasProduto);
      _categoriasProduto.forEach(nomeCategoria => o+= '- ' + nomeCategoria + '<br />');
    }

    return o;
  }

  adicionarCategoriaAoProduto(idCategoriaProduto: number, idProduto: number): Observable<void> {
    return this.httpClient.post<void>(`${CategoriaProdutoService.url}/adicionarCategoriaAoProduto/${idCategoriaProduto}/${idProduto}`, {})
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  removerCategoriaDoProduto(idCategoriaProduto: number, idProduto: number): Observable<void> {
    return this.httpClient.delete<void>(`${CategoriaProdutoService.url}/removerCategoriaDoProduto/${idCategoriaProduto}/${idProduto}`)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }
}
